import { setAPIError } from 'redux/actions';

export const handleApiError = async () => {
  const { store } = await import('App');

  if (store) {
    store.dispatch(setAPIError(true));
  }
};
